import { HttpMethod, MappedRoleAccess } from '../../domain/Role';

export const hasRoleAccess = (
  roleAccessValue: MappedRoleAccess[],
  method?: HttpMethod,
  apiUrl?: string,
) => {
  if (!apiUrl) {
    return true;
  }

  return roleAccessValue.some(
    (roleAccess) =>
      roleAccess.url === `/api/${apiUrl}` &&
      (!method || roleAccess.method === method),
  );
};
